<!-- Tab bar -->
<div class="mobile-nav-bar">
    <div class="nav-content">
        <div class="nav-scroll"
             #navScroll
             [class.fade-left]="fadeLeft"
             [class.fade-right]="fadeRight"
             (scroll)="onScroll($event)">
            @for (item of navItems; track item.label) {
                <a
                    class="nav-item"
                    [routerLink]="item.routerLink"
                    routerLinkActive="active">
                    <span
                        class="nav-icon"
                        [ngClass]="'nav-icon-' + item.icon"></span>
                    <span class="nav-label">{{ item.label }}</span>
                </a>
            }
        </div>
    </div>
    <app-rise-agent-mobile-fab *featureFlag="'riseAgent'"></app-rise-agent-mobile-fab>
</div>

